<div [dir]="functionsUtilsService.getDir()" class="kt-portlet success" *ngIf="data.type == 'success'">
	<div class="kt-portlet__head kt-portlet__head__custom">
		<div class="kt-portlet__head-progress">
			<!-- here can place a progress bar-->
			<mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
		</div>
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">{{data.title || 'DIALOG.SUCCESS' | translate}}</h3>
			<span class="kt-portlet__head-icon kt-hide">
				<i class="la la-gear"></i>
			</span>
		</div>
	</div>
	<div class="kt-form">
		<div class="kt-portlet__body">
			<div class="form-group kt-form__group row">
                <div class="col-lg-12">
                    <mat-icon>{{data.icon || 'check_circle'}}</mat-icon>
                </div>
				<div class="col-lg-12 message">
					{{viewLoading ? (data.waitMessage || 'DIALOG.WAIT_MESSAGE' | translate) : (data.message || 'DIALOG.SUCCESS_MESSAGE' | translate) }}
				</div>
			</div>
		</div>
		<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
			<div class="kt-form__actions kt-form__actions--sm">
				<button class="btn cutom-btn btn-green" (click)="onNoClick()">{{'DIALOG.OK' | translate}}</button>&nbsp;
			</div>
		</div>
	</div>
</div>


<div [dir]="functionsUtilsService.getDir()" class="kt-portlet success chashier-dialog" *ngIf="data.type == 'cashier-success'">
	<div class="kt-portlet__head__custom">
		<div class="kt-portlet__head-progress">
			<!-- here can place a progress bar-->
			<mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
		</div>
		<div (click)="onNoClick()">
			<img  class="close" src="./assets/media//cashier/x.svg">
		</div>
	</div>
	<div class="kt-form">
		<div class="kt-portlet__body">
			<div class="row">
                <div class="col-lg-12 mb-4">
					<img class="tick" src="./assets/media//cashier/tick.svg">
                </div>
				<div class="col-lg-12 message mb-3">
					{{viewLoading ? (data.waitMessage || 'DIALOG.WAIT_MESSAGE' | translate) : (data.message || 'DIALOG.SUCCESS_MESSAGE' | translate) }}
				</div>
			</div>
		</div>
		<div class="kt-portlet__foot--fit text-right">
			<div class="col-lg-6 offset-lg-3 kt-form__actions kt-form__actions--sm">
				<button class="btn cutom-btn btn-block btn-green mb-3" (click)="onNoClick()">{{'DIALOG.OK' | translate}}</button>&nbsp;
			</div>
		</div>
	</div>
</div>




<div [dir]="functionsUtilsService.getDir()" class="kt-portlet error" *ngIf="data.type == 'error'">
	<div class="kt-portlet__head kt-portlet__head__custom">
		<div class="kt-portlet__head-progress">
			<!-- here can place a progress bar-->
			<mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
		</div>
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">{{data.title || 'DIALOG.ERROR' | translate}}</h3>
			<span class="kt-portlet__head-icon kt-hide">
				<i class="la la-gear"></i>
			</span>
		</div>
	</div>
	<div class="kt-form">
		<div class="kt-portlet__body">
			<div class="form-group kt-form__group row">
                <div class="col-lg-12">
                    <mat-icon>{{data.icon || 'highlight_off'}}</mat-icon>
                </div>
				<div class="col-lg-12 message">
					{{viewLoading ? (data.waitMessage || 'DIALOG.WAIT_MESSAGE' | translate) : (data.message || 'DIALOG.ERROR_MESSAGE' | translate) }}
				</div>
			</div>
		</div>
		<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
			<div class="kt-form__actions kt-form__actions--sm">
				<button class="btn cutom-btn btn-danger" (click)="onNoClick()">{{'DIALOG.OK' | translate}}</button>&nbsp;
			</div>
		</div>
	</div>
</div>



<div [dir]="functionsUtilsService.getDir()" class="kt-portlet info" *ngIf="data.type == 'info'">
	<div class="kt-portlet__head kt-portlet__head__custom">
		<div class="kt-portlet__head-progress">
			<!-- here can place a progress bar-->
			<mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
		</div>
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">{{data.title || 'DIALOG.INFO' | translate}}</h3>
			<span class="kt-portlet__head-icon kt-hide">
				<i class="la la-gear"></i>
			</span>
		</div>
	</div>
	<div class="kt-form">
		<div class="kt-portlet__body">
			<div class="form-group kt-form__group row">
                <div class="col-lg-12">
                    <mat-icon>{{data.icon || 'info'}}</mat-icon>
                </div>
				<div class="col-lg-12 message">
					{{viewLoading ? (data.waitMessage || 'DIALOG.WAIT_MESSAGE' | translate) : (data.message || 'DIALOG.INFO_MESSAGE' | translate) }}
				</div>
			</div>
		</div>
		<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
			<div class="kt-form__actions kt-form__actions--sm">
				<button class="btn cutom-btn btn-info" (click)="onNoClick()">{{'DIALOG.OK' | translate}}</button>&nbsp;
			</div>
		</div>
	</div>
</div>




<div [dir]="functionsUtilsService.getDir()" class="kt-portlet confirm" *ngIf="data.type == 'confirm'">
	<div class="kt-portlet__head kt-portlet__head__custom">
		<div class="kt-portlet__head-progress">
			<!-- here can place a progress bar-->
			<mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
		</div>
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">{{data.title || 'DIALOG.CONFIRM' | translate}}</h3>
			<span class="kt-portlet__head-icon kt-hide">
				<i class="la la-gear"></i>
			</span>
		</div>
	</div>
	<div class="kt-form">
		<div class="kt-portlet__body">
			<div class="form-group kt-form__group row">
				<div class="col-lg-12 message">
					{{viewLoading ? (data.waitMessage || 'DIALOG.WAIT_MESSAGE' | translate) : (data.message || 'DIALOG.CONFIRM_MESSAGE' | translate) }}
				</div>
			</div>
		</div>
		<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
			<div class="d-flex justify-content-center kt-form__actions kt-form__actions--sm mb-2">
				<button class="btn cutom-btn btn-warning" (click)="onNoClick()">{{'DIALOG.CANCEL' | translate}}</button>&nbsp;
				<button class="btn cutom-btn btn-green" [disabled]="viewLoading" (click)="onYesClick()">{{'DIALOG.OK' | translate}}</button>&nbsp;
			</div>
		</div>
	</div>
</div>



<div [dir]="functionsUtilsService.getDir()" class="kt-portlet confirm" *ngIf="data.type == 'queueCarOption'">
	<div class="kt-portlet__head kt-portlet__head__custom">
		<div class="kt-portlet__head-progress">
			<!-- here can place a progress bar-->
			<mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
		</div>
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">{{data.title || 'DIALOG.CAR_OPTION' | translate}}</h3>
			<span class="kt-portlet__head-icon kt-hide">
				<i class="la la-gear"></i>
			</span>
		</div>
		<mat-icon (click)="onNoClick()" class="close-icon pull-right">close</mat-icon>
	</div>
	<div class="kt-form">
		<div class="kt-portlet__body">
			<div class="form-group kt-form__group row">
				<div class="col-lg-12 message text-uppercase">
					{{viewLoading ? (data.waitMessage || 'DIALOG.WAIT_MESSAGE' | translate) : (data.message || 'DIALOG.CONFIRM_MESSAGE' | translate) }}
				</div>
			</div>
		</div>
		<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
			<div style="margin-bottom: 17px !important;" class="d-flex justify-content-center kt-form__actions kt-form__actions--sm mb-2">
				<button class="btn cutom-btn btn-primary" (click)="onCompleteClick()">{{'DIALOG.COMPLETE_CAR' | translate}}</button>&nbsp;
			</div>
		</div>
	</div>
</div>



